import axios from "axios";

export async function useFetch (url) {
  try {
    const req = await axios(url)
    return req.data;
  } catch (error) {
    console.log(error.message);
  }
}